import React, {  useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../utils/intercepter/axiosConfig';
import { useNavigate } from 'react-router-dom';

const QuittanceTrConservation = ({id_quittance_tr_conservation, w_id}) => {

            // const {id_quittance_tr_conservation, w_id} = useParams();

            const navigate = useNavigate();
            //quittance Info
            const [montant, setMontant] = useState(null);
            const [num_qte, setNumQuittance] = useState(null);
            const [date_qte, setDateQuittance] = useState(null);
    
            const getInfoQuittanceTrConservation = async () => {
            try {
                const response = await api.post("/auth/getInfoQuittance", {
                w_id: Number(w_id),
                etat_liquidation_id: Number(id_quittance_tr_conservation)
                });

                if (response.data.status) {
                    console.log(response.data.response);
                   setMontant(response.data.response.montant);
                   setNumQuittance(response.data.response.num_qte);
                   setDateQuittance(response.data.response.date_qte);
    
                } else {
                console.error("Erreur API :", response.data.message);
                }
            } catch (err) {
                console.error("Erreur requête :", err);
            }
            };

    
    useEffect(() => {
        // console.log(id_quittance_tr_conservation)
        // console.log(w_id)
        // console.log(etat_liquidation_id_tr_conservation)
        if(id_quittance_tr_conservation && w_id ){
            getInfoQuittanceTrConservation();
        }
    },[id_quittance_tr_conservation, w_id])


  return (
    <>

    <div>
        <span className='text-start'><strong>Information de quittance</strong></span>
                           <table className='table table-bordered table-striped'>
                                <tbody>
                                        <tr>
                                            <td className='text-start'>Montant</td>
                                            <td>{montant !== null ?  montant.toLocaleString('fr-FR', {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                }) : '' } MRU
                                                </td>

                                        </tr>
                                        <tr>
                                            <td className='text-start'>Numéro</td>
                                            <td>{num_qte !== null ? num_qte.toLocaleString() : ''}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-start'>Date de création</td>
                                            <td>{date_qte || ''}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-start'>Opérations</td>
                                            <td>
                                            <button className='btn btn-success  btn-sm'>Recevoir</button>
                                            </td>
                                        </tr>
                                        </tbody>
                              </table>
    </div>
    
    </>
  )
}

export default QuittanceTrConservation

